import { DataSet } from "vue2vis";
import { fetchAsset } from "../firebase/firebase";

let generateHtmlNodeURL = function(title, progress, fillColor) {

  let componentWidth = 250;
  let progressWidth = componentWidth - 30;

  var svg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="' +
    componentWidth +
    '" height="65">' +
    '  <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" fill="' +
    fillColor +
    '" ></rect>' +
    '  <foreignObject x="15" y="10" width="100%" height="100%">' +
    '    <div xmlns="http://www.w3.org/1999/xhtml" style="font-size:40px">' +
    '      <span style="font-family: \'Exo 2\', \'IBM Plex Sans\', Helvetica, Arial, sans-serif; font-size: 1.15rem; display: block; width: 90%; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">' +
    title +
    "</span>" +
    '      <div style="margin-top: 5px; width: ' +
    progressWidth +
    'px; height: 10px; background-color: #ffffff; padding: 3px; border-radius: 4px; padding: 0">' +
    '        <div style="height: 10px; background-color: #4676cf; border-radius: 3px; width: ' +
    progress +
    '%"></div>' +
    "      </div>" +
    "    </div>" +
    "  </foreignObject>" +
    "</svg>";

  // console.log("svg: ", svg);

  var url = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  // console.log("url: ", url);
  return url;
};

export default {

  currentUserGraphInput: null,

  searchGraphs: function() {
    return [ 
      this.getGraphInput_Wald(), 
      this.getGraphInput_Wasser(), 
      this.getGraphInput_Aegypten(),
      this.getGraphInput_Mathe()
    ];
  },
  getAllGraphs: function() {
    return [ 
      this.getCurrentUserGraphInput(), 
      this.getGraphInput_Wald(), 
      this.getGraphInput_Wasser(), 
      this.getGraphInput_Aegypten(),
      this.getGraphInput_Mathe()
    ];
  },

  getCurrentUserGraphInput: function() {
    if(this.currentUserGraphInput === null) {
      this.currentUserGraphInput = this.getGraphInput_Aegypten();
      this.currentUserGraphInput.id = 0;
      this.currentUserGraphInput.name = 'CURRENTUSER';
    }
    return this.currentUserGraphInput;
  },

  mergeGraphIntoCurrentUser: function(graphId) {
    console.log("merging two graphs")
    let graphInput = this.getGraphInputById(graphId); 
    if(this.currentUserGraphInput.nodes.find(node => {
      return graphInput.nodes.some(node2 => {
        return node2.id === node.id;
      })
    })){
      console.log("Duplciate Graph");
      
    }else{
      Array.prototype.push.apply(this.currentUserGraphInput.nodes, graphInput.nodes);
      Array.prototype.push.apply(this.currentUserGraphInput.edges, graphInput.edges);
    }

    // generate a new random id
    let min = Math.ceil(100);
    let max = Math.floor(200);
    let random =  Math.floor(Math.random() * (max - min + 1)) + min;
    this.currentUserGraphInput.id = random;
    console.log(this.currentUserGraphInput)
    return random;
  },

  mergeGraphs: function(firstGraphId, secondGraphId) {
    console.log("merging two graphs")
    let graphOne = this.getGraphInputById(firstGraphId); 
    let graphTwo = this.getGraphInputById(secondGraphId);

    const nodes = Array.prototype.push.apply(graphOne.nodes, graphTwo.nodes);
    const edges = Array.prototype.push.apply(graphOne.edges, graphTwo.edges);
    this.currentUserGraphInput = this.getGraphByGraphInput({nodes, edges});
    // generate a new random id
    let min = Math.ceil(10);
    let max = Math.floor(20);
    let random =  Math.floor(Math.random() * (max - min + 1)) + min;
    this.currentUserGraphInput.name = "CURRENTUSER";
    this.currentUserGraphInput.id = random;
    return random;
  },

  getGraphInput_Wald: function() {
    const color = '#5de884';
    const nodes = [
      {
        id: 10,
        title: "Der Wald",
        abstract: "Herzlich Willkommen zum Thema 'Der Wald'. Wer geht nicht gern in den Wald ? Die Vögel zwitschern, die Blätter rauschen, es gibt wahnsinnig viel zu entdecken und man kann die tollsten Buden bauen. Aber was weisst du eigentlich über den Wald? Wir haben dir hier einen Lernpfad zusammengestellt, der dir helfen kann den Wald besser zu verstehen. Viel Spass und viel Erfolg bei der Herausforderung...",
        shape: "image",
        progress: 0,
        color: '#fff',
        isChallenge: true
      },
      {
        id: 11,
        title: "Einführung",
        abstract:
          "Wald (Waldung) im alltagssprachlichen Sinn und im Sinn der meisten Fachsprachen ist ein Ausschnitt der Erdoberfläche, der mit Bäumen bedeckt ist und eine gewisse, vom Deutungszusammenhang abhängige Mindestdeckung und Mindestgröße überschreitet. Die Definition von Wald ist notwendigerweise vage und hängt vom Bedeutungszusammenhang (alltagssprachlich, geographisch, biologisch, juristisch, ökonomisch, kulturell) ab. [Wikipedia]",
        materials: [
          {
            id: 0,
            label: "Wald (Wikipedia Artikel)",
            url: "https://de.wikipedia.org/wiki/Wald",
            type: "checkbox",
            time: 20
          },
          {
            id: 1,
            label:
              "Unsere Wälder (1/3): Die Sprache der Bäume | Ganze Folge Terra X",
            url: "https://www.youtube.com/watch?v=wXgvxooJaPE",
            type: "checkbox",
            time: 45
          },
        ],
        shape: "image",
        progress: 100,
        color: color
      },
      {
        id: 12,
        title: "Stockwerke des Waldes",
        abstract: "Die unterste Schicht ist die Moos- oder auch Bodenschicht, die von Moosen und Pilzen gebildet wird. Zu dieser Schicht zählen auch niedere Blütenpflanzen wie Sauerklee und Haselwurz. Die Moosschicht ist Lebensraum für viele Insekten, Spinnen, Reptilien und Kleinsäuger (Maus, Igel).",
        materials: [
          {
            id: 0,
            label: "Stockwerke des Waldes | wald.de",
            url: "https://www.wald.de/stockwerke-des-waldes/#:~:text=Der%20Stockwerkaufbau%20des%20Waldes%3A&text=Die%20unterste%20Schicht%20ist%20die,Kleins%C3%A4uger%20(Maus%2C%20Igel).",
            type: "checkbox",
            time: 5
          },
          {
            id: 1,
            label:
              "Stockwerke des Waldes | biologie-schule.de",
            url: "http://www.biologie-schule.de/stockwerke-des-waldes.php",
            type: "checkbox",
            time: 10
          },
        ],
        shape: "image",
        progress: 80,
        color: color
      },
      {
        id: 13,
        title: "Aufbau eines Baumes",
        abstract: "hier Info über den Aufbau eines Baumes",
        shape: "image",
        progress: 40,
        color: color
      },
      {
        id: 14,
        title: "Laubbäume",
        abstract: "Laubbäume",
        shape: "image",
        progress: 10,
        color: color
      },
      {
        id: 15,
        title: "Mischwälder",
        abstract: "...",
        shape: "image",
        progress: 0,
        color: color
      },
      {
        id: 16,
        title: "Nadelbäume",
        abstract: "hier Info über den Aufbau eines Baumes",
        shape: "image",
        progress: 0,
        color: color
      },
      {
        id: 17,
        title: "Waldarten",
        abstract: "waldarten abstract here",
        shape: "image",
        progress: 89,
        color: color
      },
      {
        id: 18,
        title: "Tiere des Waldes",
        abstract: "The Fox is in the box",
        shape: "image",
        progress: 0,
        color: color
      },
      {
        id: 19,
        title: "Pilze",
        abstract: "booohr good stuff",
        shape: "image",
        progress: 0,
        color: color
      },
    ];
    const edges = [
      { from: 10, to: 11 },
      { from: 11, to: 12 },
      { from: 12, to: 13 },
      { from: 13, to: 14 },
      { from: 13, to: 16 },
      { from: 15, to: 17 },
      { from: 16, to: 17 },
      { from: 17, to: 18 },
      { from: 14, to: 17 },
      { from: 13, to: 17 },
      { from: 18, to: 19 },
    ];
    const graphPaylod = {
      id: 1,
      name: 'Der Wald',
      nodes: nodes,
      edges: edges,
      color: color
    };
    return graphPaylod;
  },

  getGraphInput_Wasser: function() {
    const color = '#50a5fa';
    const nodes = [
      {
        id: 20,
        title: "Was ist Wasser",
        abstract:
          "Wasser (H2O) ist eine chemische Verbindung aus den Elementen Sauerstoff (O) und Wasserstoff (H). Wasser ist als Flüssigkeit durchsichtig, weitgehend farb-, geruch- und geschmacklos. Es kommt in zwei Isomeren (para- und ortho-Wasser) vor, die sich im Kernspin der beiden Wasserstoffatome unterscheiden. Wasser ist die einzige chemische Verbindung auf der Erde, die in der Natur als Flüssigkeit, als Festkörper und als Gas vorkommt. Die Bezeichnung Wasser wird dabei für den flüssigen Aggregatzustand verwendet. Im festen Zustand spricht man von Eis, im gasförmigen Zustand von Wasserdampf. Wasser ist Grundlage des Lebens auf der Erde. In der Natur kommt Wasser selten rein vor, sondern enthält meist gelöste Anteile von Salzen, Gasen und organischen Verbindungen.",
        materials: [
          {
            id: 0,
            label: "Wasser | Wikipedia",
            url: "https://de.wikipedia.org/wiki/Wasser",
            type: "checkbox",
          },
          {
            id: 1,
            label:
              "Aggregatzustände des Wassers | Wikipedia",
            url: "https://de.wikipedia.org/wiki/Aggregatzustand",
            type: "checkbox",
          },
          {
            id: 2,
            label:
              "Checker Tobi und das Geheimnis unseres Planeten | | Kinofilm",
            url: "https://www.youtube.com/watch?v=hkliMWnsnNE",
            type: "checkbox",
          },
        ],
        shape: "image",
        progress: 10,
        color: '#fff'
      },
      {
        id: 21,
        title: "Ozeane der Erde",
        abstract: "Als Ozean (Plural 'die Ozeane', von altgriechisch Ὠκεανός Ōkeanós, deutsch ‚der die Erdscheibe umfließende Weltstrom‘, personifiziert als antiker Gott Okeanos) bezeichnet man die größten Meere der Erde. Synonym und als Übertragung wird im Deutschen auch die Bezeichnung Weltmeer verwandt.",
        materials: [
          {
            id: 0,
            label: "Ozeane | Wikipedia",
            url: "https://de.wikipedia.org/wiki/Ozean",
            type: "checkbox",
          },
          {
            id: 1,
            label:
              "Arktischer Ozean | Wikipedia",
            url: "https://de.wikipedia.org/wiki/Arktischer_Ozean",
            type: "checkbox",
          },
          {
            id: 2,
            label:
              "Meeresströmungen | Wikipedia",
            url: "https://de.wikipedia.org/wiki/Meeresstr%C3%B6mung",
            type: "checkbox",
          },
        ],
        shape: "image",
        progress: 10,
        color: color
      },
      {
        id: 22,
        title: "Wasservorkommen der Antarktis",
        abstract: "hier Info über den Aufbau eines Baumes",
        shape: "image",
        progress: 40,
        color: color
      },
    ];
    const edges = [
      { from: 20, to: 21 },
      { from: 21, to: 22 },
      { from: 22, to: 23 },
      { from: 20, to: 23 },
    ];
    const graphPaylod = {
      id: 2,
      name: 'Wasser',
      nodes: nodes,
      edges: edges,
      color: color
    };
    return graphPaylod;
  },

  getGraphInput_Aegypten: function(){
    const color = '#f5b25b';
    const nodes = [
        {
          id: 30,
          title: "Ägypten",
          abstract: "Pyramiden, die Sphinx, der Nil, unsterbliche Götter und eine Jahrtausende alte Kultur. Herzlich Willkommen zum Thema 'Ägypten'. Du willst mehr wissen über die Pharaonen, geheimnisvolle Hieroglyphen, sagenumwogene Bauwerke die Jahrtausende überdauerten? Dann bist du bei diesem Thema goldrichtig. Wir haben dir hier einen Lernpfad zusammengestellt, der dir helfen kann Ägypten besser zu verstehen. Viel Spass und viel Erfolg bei der Herausforderung...",
          shape: "image",
          progress: 0,
          color: '#fff',
          isChallenge: true
        },
        { 
            id: 31, 
            title: "Ägypten - Einleitung",
            abstract: "Als die Menschen in Europa noch in der Steinzeit lebten, entwickelte sich am Nil bereits eine erste Hochkultur. Die alten Ägypter erfanden eine eigene Schrift, die Hieroglyphen. Sie bauten schon vor tausenden Jahren Pyramiden, die man noch heute bestaunen kann. Ihr Reich bestand alles in allem ca. 4500 Jahre und bis heute haben wir noch lange nicht alle Geheimnisse der alten Ägypter gelüftet. Vielleicht kannst du uns dabei helfen, noch mehr Licht ins Dunkle zu bringen? ",
            materials: [
                { id: 0, label: "Altes Ägypten | Wikipedia", url: "https://de.wikipedia.org/wiki/Altes_%C3%84gypten", time: 25, type: "checkbox" },
                { id: 1, label: "Geschichte des alten Ägypten", url: "https://de.wikipedia.org/wiki/Geschichte_des_Alten_%C3%84gypten", time: 30, type: "checkbox" },
                { id: 2, label: "Gesellschaft des alten Ägyptens", url: "https://www.youtube.com/watch?v=qPSjHDhDZPk", time: 10, type: "checkbox" },
                { id: 3, label: "Ägypten Doku TerraX Teil 1 Geburt des Pharaonenreichs", url: "https://www.youtube.com/watch?v=C1sd-6UkpNs", time: 45, type: "checkbox" }
            ],
            shape: "image",
            progress: 35,
            color: color
        },
        { 
            id: 32, 
            title: "Der Nil – Vater Ägyptens",
            abstract: 'Ohne den Nil gäbe es kein Leben in Ägypten, denn außer dem schmalen Streifen fruchtbaren Landes besteht Ägypten zu großen Teilen aus Wüste. Die Besonderheiten des Lebensraumes am Nil werden in diesem Schwerpunkt untersucht.',
            materials: [
                { id: 0, label: "LB Geschichte S. 23-28", type: "checkbox" },
                { id: 1, label: "LB Geographie S. 45-50", type: "checkbox" },
                { id: 2, label: "LB Geschichte S. 23-28", type: "checkbox" },
                { id: 3, label: "Bibliothek", type: "checkbox" },
                { id: 4, label: "Kopie: Karte Ägyptens, schwarz-weiß.pdf", type: "checkbox" },
                { id: 5, label: "Youtube Kanal WasIstWas", url:"https://www.youtube.de/wasistwas", type: "checkbox" },
            ],
            tasks:[
              { id: 0, label: "Einzelarbeit: Erstelle einen Steckbrief zum Nil. Nutze das Material unten als Ausgangspunkt deiner Recherchen. Die Karte kannst du verwenden, wenn du keine eigene erstellen möchtest. Eine ansprechende und kreative Gestaltung des Steckbriefs ist wichtig!", type: "checkbox" },
              { id: 1, label: "Gruppenarbeit (3 Personen): Aufgabe ist die Erstellung eines Radio- oder Videobeitrags zum Thema 'Die Funktionen des Nils'. Nehmt euren Beitrag mit dem Handy auf. Dauer: mindestens drei, maximal fünf Minuten. Entscheidet selbst, welches Thema ihr bearbeiten wollt: (A) Die Funktionen der Nilschwemme (verwendet die Begriffe: Nilflut, Bauern, Felder/Plantagen, Trinkwasser, Schlamm, Papyrus, Bewässerungssystem)ODER (B) Der Nil als Transport und Handelsweg (wichtige Begriffe: Händler, Beamte, Truppen) sowie die Funktion des Assuan-Staudamms (Wo befindet er sich, wann wurde er gebaut, welche Probleme löst er, welche neuen Problemeschafft er) Geht arbeitsteilig vor und verteilt die Aufgaben untereinander.", type: "checkbox" }
            ],
            shape: "image",
            progress: 10,
            color: color
        },
        { 
            id: 33, 
            title: "Die Pyramiden",
            abstract: 'Wenn du die Augen schließt und denkst an Ägypten, woran denkst duzuerst..? – Richtig! Die Pyramiden. Seit tausenden Jahren sind es die Wahrzeichen, die am Nil in den Himmel ragen. ',
            materials: [
                { id: 0, label: "LB Geschichte S. 34-38", type: "checkbox" },
                { id: 1, label: "LB Geographie S. 45-50", type: "checkbox" },
                { id: 2, label: "Bibliothek", type: "checkbox" },
                { id: 3, label: "Youtube Kanal WasIstWas", url:"https://www.youtube.de/wasistwas", type: "checkbox" },
            ],
            tasks:[
              { id: 0, label: "Einzelarbeit: Erstelle einen Steckbrief zu einer berühmten Pyramide. ", type: "checkbox" }
            ],
            shape: "image",
            progress: 60,
            color: color
        },
        { 
            id: 34, 
            title: "Die  Mumifizierung der Verstorbenen",
            abstract: 'Der Glaube der Ägypter fokusiert das Leben nach dem Tod. So brauche die Seele einen Weg zur Rückkehr zum Haus des Toten. Daher soll der Körper soll erhalten werden. Desweiteren begleiten Götter die Toten ins Totenreich',
            materials: [
                { id: 0, label: "Der Bericht des Schreibers Hunifer über sein Totengericht", type: "checkbox" },
                { id: 1, label: "Verfahren der Mumifizierung, Zeremonie, Geräte, Fachleute", type: "checkbox" },
                { id: 2, label: "Mumifizierung von Tieren ", type: "checkbox" },
                { id: 3, label: "Götter im Totengericht", type: "checkbox" }
            ],
            shape: "image",
            progress: 12,
            color: color
        },
        { 
            id: 35, 
            title: "Mächtige Göttinnen und Götter",
            abstract: 'Götter prägten das Leben und den Tod der Menschen im alten Ägypten. Es gab eine Vielzahl von Göttern mit unterschiedlichstem Aussehen und verschiedenen Aufgaben.',
            materials: [
                { id: 0, label: "Göttererzählungen", type: "checkbox" },
                { id: 1, label: "Götter im Totengericht", type: "checkbox" },
                { id: 2, label: "Bibliothek", type: "checkbox" }
            ],
            tasks:[
              { id: 0, label: "Einzelarbeit: Erstelle Steckbriefe der Götterwelt (Namen, Wohnorte, Symbole, Aufgaben, Aussehen). Wähle 5 Gottheiten.", type: "checkbox" }
            ],
            shape: "image",
            progress: 0,
            color: color
        },
        { 
            id: 36, 
            title: "Pharao , König im Bund mit den Göttern",
            abstract: 'Pharaonen - gottgleiche Wesen oder auch nur Menschen? Sie waren direkt mit den Göttern verbunden und besaßen daher viel Macht. Die Ägypter verehrten ihre Herrscher, sodass sie auch Pyramiden für sie erbauten.',
            materials: [
                { id: 0, label: "LB Geschichte S. 34-38", type: "checkbox" },
                { id: 1, label: "LB Geographie S. 45-50", type: "checkbox" },
                { id: 2, label: "Bibliothek", type: "checkbox" },
            ],
            tasks: [
              { id: 0, label: "Gruppenarbeit: Erstellt einen Stammbaum, der die Pharaonen von 2000 v.Chr. bis 1400 v.Chr. chronologisch ordnet.", type: "checkbox" }
            ],
            shape: "image",
            progress: 0,
            color: color
        },{ 
            id: 37, 
            title: "Die Katze, das heiliges Tier der alten Ägypter",
            abstract: 'Die Katze galt besonders heilig im alten Ägypten. Bastet - eine Götting Gestalt einer Katze - ist nur ein Grund, dass Katzen verehrt wurden.',
            materials: [
                        { id: 0, label: "LB Geschichte S. 41-44", type: "checkbox" },
                        { id: 1, label: "Bibliothek", type: "checkbox" },
                    ],
            tasks: [
              { id: 0, label: "Einzelarbeit: Finde heraus, warum Katzen so verehrt wurden und fasse deine Ergebnisse auf einer A4 Seite zusammen.", type: "checkbox" }
            ],
            shape: "image",
            progress: 0,
            color: color
        },
    ];
    const edges = [
        { from: 30, to: 31 },
        { from: 31, to: 32 },
        { from: 32, to: 33,},
        { from: 33, to: 34 },
        { from: 33, to: 35 },
        { from: 33, to: 36 },
        { from: 34, to: 36 },
        { from: 36, to: 35 },
        { from: 35, to: 37,}
    ];
    const graphPaylod = {
        id: 3,
        name: 'Ägypten',
        nodes: nodes,
        edges: edges,
        color: color
    }
    return graphPaylod;
  },

  getGraphInput_Mathe: function(){
    const color = '#d775fa';
    const nodes = [
        { 
            id: 40, 
            title: "Dreiecke",
            abstract: "Drei Ecken bedarf es um diese Geometrische Figur zu zeichnen. Bereits die alten Griechen Pythagoras und Euklid waren von Dreiecken fasziniert und haben verschiedene Mathematische Sätze definiert. Doch auch in der heutigen Welt spielen Dreiecke eine große Rolle. Triangulation ist ein Verfahren zur Messung von Entfernungen und wird für GPS verwendet.",
            shape: "image",
            progress: 0,
            color: '#fff'
        },
        { 
            id: 41, 
            title: "Umfang",
            abstract: 'Wie berechnet man den Umfang eines Dreiecks?',
            materials: [
                { id: 0, label: "Mathe plus 6, S.177 blauer Kasten", type: "checkbox" },
                { id: 1, label: "Fundamente der Mathematik, S.141 gelber Kasten,", type: "checkbox" },
            ],
            tasks:[
            { id: 0, label: "Einzelarbeit: Mathe plus 6, S.178 5 a-d, 7a", type: "checkbox" },
            { id: 1, label: "Einzelarbeit: Fundamente der Mathematik, S.141 7 und 8", type: "checkbox" }
            ],
            shape: "image",
            progress: 0,
            color: color
        },
        { 
            id: 42, 
            title: "Flächenberechnungen",
            abstract: 'Wie berechnet man die Fläche eines Dreiecks?',
            materials: [
                { id: 0, label: "Mathe plus 6, S.179 blauer Kasten", type: "checkbox" },
                { id: 1, label: "Fundamente der Mathematik, S.139 gelber Kasten", type: "checkbox" },
                { id: 2, label: "Arbeitsblätter: Flächeninhalt rechtwinkliges Dreieck, Flächeninhalt eines Dreiecks & Berechnung des Flächeninhaltes", type: "checkbox" },
            ],
            tasks:[
                { id: 0, label: "Gruppenarbeit: Notiert eure Erkenntnisse in euren Aufzeichnungen", type: "checkbox" },
                { id: 1, label: "Einzelarbeit: Mathe plus 6, S.180 4 a-d, 5 a-d, 6", type: "checkbox" },
                { id: 2, label: "Einzelarbeit: Fundamente der Mathematik, S.140 1, 2, 3 a-d, 5", type: "checkbox" },
                { id: 3, label: "Einzelarbeit: Bearbeite die Arbeitsblätter in den Materialien", type: "checkbox" }
            ],
            shape: "image",
            progress: 0,
            color: color
        },
        { 
            id: 43, 
            title: "Dreiecke  - Umfang-/Flächenberechnungen",
            abstract: 'Du hast noch nicht genug von Dreiecken? Hier gibt es weitere Aufgaben!',
            tasks:[
                { id: 0, label: "Übekartei 8 – Seite 68-74", type: "checkbox" },
                { id: 1, label: "Mathe plus 6, S.181 Aufgaben 11, 12, 14, 15, 17, 18", type: "checkbox" },
                { id: 2, label: "Mathe plus 6, S.186 Aufgaben 7 d)", type: "checkbox" },
                { id: 3, label: "Fundamente der Mathematik, S.143 Aufgaben 13, 14, 17, 18, 19, 21", type: "checkbox" }
            ],
            shape: "image",
            progress: 0,
            color: color
        },
        { 
            id: 44, 
            title: "Triangulation",
            abstract: 'Die Triangulation ist ein Verfahren zur Messung von Entfernung. Sie basiert auf der Verwendung von Dreicken.',
            materials: [
                { id: 0, label: "Triangulation in der Messtechnik", url:"https://de.wikipedia.org/wiki/Triangulation_(Messtechnik)", type: "checkbox" },
            ],
            tasks:[
                { id: 0, label: "Gruppenarbeit: Erarbeitet eine Übersicht für welche Berufe die Triangulation auch heute noch eine Rolle spielt. Findet 5 Berufe und erklärt stichpunktartig die Bedeutung der Triangulation für diese Berufe.", type: "checkbox" }
            ],
            
            shape: "image",
            progress: 0,
            color: color
        }
    ];
    const edges = [
        { from: 40, to: 41 },
        { from: 41, to: 43,},
        { from: 40, to: 42 },
        { from: 42, to: 43 },
        { from: 42, to: 44 },
        { from: 41, to: 44 }
    ];
    const graphPaylod = {
        id: 4,
        name: 'Dreiecke',
        nodes: nodes,
        edges: edges,
        color: color
    }
    return graphPaylod;
  },

  
  getGraphByUserId: function(userId) {
    console.log("requested graph for userId: ", userId)
    // return this.getGraphByGraphInput( this.getGraphInput_Aegypten() );
    return this.getGraphByGraphInput( this.getCurrentUserGraphInput() );
  },

  // returns the actual graph by a given simplified graphInput
  getGraphByGraphInput: function(graphInput) {
    
    // if(!graphInput) 
    // return {
    //   nodes: new DataSet([]),
    //   edges: new DataSet([]),
    //   options: {}
    // }

    const mappedNodes = graphInput.nodes.map((node) => {
      const mappedNode = {
        ...node,
      };
      mappedNode.image = generateHtmlNodeURL(node.title, node.progress, node.color);
      return mappedNode;
    });
    // const mappedEdges = graphInput ? graphInput.edges : [];
    
    const result = {
      nodes: new DataSet(mappedNodes),
      edges: new DataSet(graphInput.edges),
      options: {
        layout: {
          randomSeed: 8,
        },
        physics: {
          enabled: true,
          solver: "repulsion",
          repulsion: {
            nodeDistance: 120,
          },
        },
      },
    };
    return result;
  },

  getGraphInputById: function(graphId) {
    let availableGraphInputs = this.getAllGraphs();
    for(let i=0; i < availableGraphInputs.length; i++) {
      let singleGraphInput = availableGraphInputs[i];
      if(singleGraphInput.id === graphId) return singleGraphInput;
    }
  },
  // renders a graph based on its ID in the database
  getGraphById: function(schoolId, graphId) {
    console.log(
      "trying to load graph for school " + schoolId + " and graph " + graphId
    );

    return new Promise((resolve, reject) => {
      let graphInput = this.getGraphInputById(graphId);
      let graph = this.getGraphByGraphInput(graphInput);
      resolve( graph ); 
      // let availableGraphInputs = this.getAllGraphs();
      // for(let i=0; i < availableGraphInputs.length; i++) {
      //   let singleGraphInput = availableGraphInputs[i];
      //   console.log("looking at graphInput : ", singleGraphInput)
      //   if(singleGraphInput.id === graphId) {
      //     let graph = this.getGraphByGraphInput(singleGraphInput);
      //     console.log("graph result: ", graph)
      //     resolve( graph ); 
      //   }
      // }
      return reject();
    });
  },

  // retrieves the graph from the database
  getGraphByIdReal: function(schoolId, graphId) {
    console.log(
      "trying to load graph for school " + schoolId + " and graph " + graphId
    );

    return new Promise((resolve, reject) => {
      this.unsubscribe = fetchAsset(schoolId, graphId).onSnapshot(
        (querySnapshot) => {
          const $data = querySnapshot.data();
          let asset = {
            $id: querySnapshot.id,
            name: $data.name,
            network: {
              nodes: new DataSet($data.nodes),
              edges: new DataSet($data.edges),
              options: {
                groups: {
                  switch: {
                    shape: "box",
                    color: "#24d453", // green
                  },
                },
              },
            },
          };
          console.log("asset: ", asset);

          if (!asset) return reject();
          return resolve(asset);
        }
      );
    });
  },
};
